import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import PragyaLimsHomePage from "./Components/PragyaLimsHomePage";

function App() {
  return (
    <>
      <PragyaLimsHomePage />
    </>
  );
}

export default App;
